import classNames from "classnames";
import ErrorBoundary from "./ErrorBoundary";
import { SearchAutocompleteSection } from "./SearchAutocompleteSection";
import { Loader } from "~/common/icons/Loader";
import { SearchResponse } from "~/models/search-result";
import { SearchResultsLink } from "./SearchResultsLink";

export function SearchAutocompleteResults({
  loading,
  hasError,
  searchData,
  searchTerm,
}: {
  loading: boolean;
  hasError: boolean;
  searchData: SearchResponse;
  searchTerm: string;
}) {
  return (
    <div
      className={classNames(
        "search-results-container",
        "tw:w-full tw:min-h-[8rem] tw:mt-2 tw:bg-white tw:py-5",
        "tw:!border tw:!border-[#a6abbd] tw:!border-opacity-60",
        "tw:z-50 tw:rounded-[1.25rem] tw:shadow-lg tw:overflow-hidden",
      )}
    >
      <ErrorBoundary>
        {loading && (
          <Loader
            data-testid="Loader"
            className="tw:!absolute tw:!top-5 tw:!right-5"
          />
        )}
        <div
          className="tw:!px-6 tw:!h-full tw:!mb-12 tw:!max-h-[70vh] tw:!overflow-y-auto"
          data-testid="Sections"
        >
          {hasError && (
            <p>Sorry, there was a problem. Please try your search again.</p>
          )}
          {searchData.data &&
            searchData.data.searchAutocomplete &&
            searchData.data.searchAutocomplete!.map((section) => (
              <SearchAutocompleteSection
                key={section.title}
                searchTerm={searchTerm}
                title={section.title}
                results={section.results}
              />
            ))}
        </div>
      </ErrorBoundary>

      <div
        className={classNames(
          "tw:!absolute tw:!bottom-0 tw:!left-0 tw:w-full",
          "tw:!flex tw:!items-center",
          "tw:!bg-white tw:!h-16",
          "tw:!border tw:!border-[#a6abbd] tw:!border-opacity-60 tw:!rounded-b-[1.25rem]",
        )}
      >
        <SearchResultsLink searchTerm={searchTerm} />
      </div>
    </div>
  );
}
